import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const ProgramTypeBlueIcon = ({ label = 'ProgramTypeBlue', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path style="fill:#85cee3" d="M108.3 56.4h116.6v142.57H108.3z"/><path d="M233.1 237.8a4.9 4.9 0 0 1 4.8 4.9v3.2a4.9 4.9 0 0 1-4.8 4.9H88.9a32.4 32.4 0 0 1-32.4-32.4V75.8a32.4 32.4 0 0 1 32.4-32.4h139.3a9.6 9.6 0 0 1 9.7 9.7v149.1a9.9 9.9 0 0 1-6 9c-1.5 6.5-1.8 18.4-.2 26.6zm-12.9-25.9H88.9c-25.9 0-25.9 25.9 0 25.9h131.3a93.6 93.6 0 0 1 0-25.9zm-131.3-13h6.5V56.4h-6.5a19.4 19.4 0 0 0-19.5 19.4v129.6a33.1 33.1 0 0 1 19.5-6.5zm136.1 0V56.4H108.3v142.5zm-92.4-90.7a4.8 4.8 0 0 1-4.8-4.8v-3.3a4.7 4.7 0 0 1 4.8-4.8h68.1a4.8 4.8 0 0 1 4.8 4.8v3.3a4.9 4.9 0 0 1-4.8 4.8zm68.1 25.9h-68.1a4.8 4.8 0 0 1-4.8-4.8V126a4.8 4.8 0 0 1 4.8-4.8h68.1a4.9 4.9 0 0 1 4.8 4.8v3.3a4.9 4.9 0 0 1-4.8 4.8z"/></svg>`}
    />
  )
}

ProgramTypeBlueIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { ProgramTypeBlueIcon }
